/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Install_Step_2Inputs */

const fr_install_step_2 = /** @type {(inputs: Install_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluez le script dans votre page HTML :`)
};

const en_install_step_2 = /** @type {(inputs: Install_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include the script in your HTML page:`)
};

/**
* | output |
* | --- |
* | "Include the script in your HTML page:" |
*
* @param {Install_Step_2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const install_step_2 = /** @type {((inputs?: Install_Step_2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Step_2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_install_step_2(inputs)
	return en_install_step_2(inputs)
});